import React from "react";
import { connect } from "react-redux";
import { getChannels } from "../../redux/actions/messengerActions";
import Table from "../../components/Table";
import Card from "../../components/Card";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import MemberAvatar from "./MemberAvatar";
function Channels(props) {
  const { channels, data, loading } = props.messenger;
  const columns = [
    {
      id: "image",
      Header: "Bild",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          <Link to={`/messenger/${props.original._id}`}>
            {props.original.member && (
              <MemberAvatar
                src={props.original.member.profile.picture}
                alt={props.original.member.profile.name}
                lastMessageSeen={props.original.lastMessageSeen}
              />
            )}
          </Link>
        </React.Fragment>
      ),
    },

    {
      id: "name",
      Header: "Kunden",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          <Link to={`/messenger/${props.original._id}`}>
            {props.original.lastMessageSeen === true ? (
              <span>
                {props.original.member && props.original.member.username}
              </span>
            ) : (
              <strong>
                {props.original.member && props.original.member.username}
              </strong>
            )}
          </Link>
        </React.Fragment>
      ),
    },
    {
      id: "in",
      Header: "IN",
      accessor: (d) => d._id,
      Cell: (props) => <React.Fragment>{props.original.in}</React.Fragment>,
    },
    {
      id: "lastAction",
      Header: "Last Action",
      accessor: (d) => d._id,
      Cell: (props) => <Moment>{props.original.updatedAt}</Moment>,
    },
    {
      id: "out",
      Header: "Out",
      accessor: (d) => d._id,
      Cell: (props) => <React.Fragment>{props.original.out}</React.Fragment>,
    },
    {
      id: "profile",
      Header: "Profile",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          {props.original.user && props.original.user.username}
        </React.Fragment>
      ),
    },
    {
      id: "profileImage",
      Header: "Profile image",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          {props.original.user && (
            <Avatar
              src={props.original.user.profile.picture}
              alt={props.original.user.profile.name}
            />
          )}
        </React.Fragment>
      ),
    },
  ];

  return (
    <Card title="Active dialogues" style={{ marginTop: 15 }}>
      <Table
        data={channels}
        columns={columns}
        loading={loading}
        page={!data.pagination ? 0 : data.pagination.current - 1}
        pages={!data.pagination ? 1 : data.pagination.total}
        onFetchData={(state) => {
          var queryString = state.filtered
            .map((key) => key.id + "=" + key.value)
            .join("&");
          let query = `?page=${state.page + 1}&member=${
            props.userId
          }&${queryString}`;
          props.getChannels(query);
        }}
        noDataText="This user is not talking with any chatters!"
        minRows={5}
      />
    </Card>
  );
}

const mapStateToProps = (state) => ({
  messenger: state.messenger,
});

export default connect(mapStateToProps, { getChannels })(Channels);
